/**
 * What the success and hold pages can offer a returning visitor.
 *
 * Booking, calls and contact-center checks run against the lead the server
 * session is bound to. An anonymous session has none, even when this browser
 * still holds an "already applied" record (an application from before the
 * server-managed session that could not be claimed), so it starts over. A
 * recent rejection, whether it ended on the offer wall or the unsuccessful
 * page, still shows its hold page: that view makes no server calls.
 */
export type TerminalAccess = 'checking' | 'full' | 'local-only' | 'start-over';

const ANONYMOUS_STAGE = 'anonymous';

export const resolveTerminalAccess = ({
  serverStage,
  hasRecentRejection,
}: {
  /** Null when there is no server-managed session to ask (legacy or mock service, or the lookup failed). */
  serverStage: string | null;
  /** This browser applied within the block window and was not accepted. */
  hasRecentRejection: boolean;
}): Exclude<TerminalAccess, 'checking'> => {
  if (serverStage !== ANONYMOUS_STAGE) return 'full';
  return hasRecentRejection ? 'local-only' : 'start-over';
};
